<template>
    <v-app-bar
      app
      color="white"
      height="100"
    >
      <v-avatar
        class="mr-3"
        color="grey lighten-5"
        size="70"
      >
        <v-img
          contain
          max-height="70%"
          src="https://arowe-portfolio.netlify.app/img/a-dot-r_logo.7e1668c7.png"
        ></v-img>
      </v-avatar>

      <v-toolbar-title class="font-weight-black headline">
        {{title}}
      </v-toolbar-title>
    </v-app-bar>

</template>

<script>
export default {
  name: "Header",

  data: () => ({
    //
    title: "A.Rowe"
  })
};
</script>
